import {FC,useState,useEffect} from 'react'
import ProductList from './ProductList'
import {GETPRODUCTSETUP} from '../../../../utils/GraphQLAPI'
import { useLazyQuery} from '@apollo/client'
import ProductSetup from './ProductSetup'

const TeamAdminProducts: FC = () => {
  const [editedData,setEditedData] = useState<any>()

  // Get Client Details query
  const [getProductSetup,{loading,data}] = useLazyQuery(GETPRODUCTSETUP, {
    onCompleted: (resData) => {
      setLocalData(resData)
    },
    fetchPolicy:"network-only"
  })

  const setLocalData = (fetchData:any) => {
    const fetchedItems:any=[]
    fetchData?.getProductDetail?.forEach((item:any) => {
      if(item.enum!=="UTILITY"){
        item.names.forEach((objData:any) => fetchedItems.push({...objData, enum:item.enum}))
      }
      
    })
    setEditedData(fetchedItems)
  }
  
  useEffect(() => {
    getProductSetup()
  },[])
  
  return (
    <>
      <div
        className='d-flex flex-row justify-content-between align-items-center mb-5'
      >
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>Products</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - Products</span>
        </div>
        <div className=''>
          <ProductSetup editedData={editedData} getProductSetup={getProductSetup} loading={loading} data={data} setEditedData={setEditedData}/>
        </div>
      </div>
      <ProductList filterData={data}  getProductSetup={getProductSetup} />
    </>
  )
}

export {TeamAdminProducts}
